// Translation object
  const translations = {
    "en": {
      "form": {
        "error_email": "Please enter your email address.",
        "error_valid_email": "Please enter a valid email address",
        "error_email_char_limit":"Your email address cannot be longer than 100 characters",
        "error_password_blank": "Please enter a password.",
        "error_password_limit": "Password must be at least 6 characters long",
        "error_password_validate":"Password must contain numbers, letters, and special characters",
        "error_first_name": "Please enter your first name",
        "error_first_valid_name": "Please enter a valid first name",
        "error_last_name": "Please enter your last name",
        "error_last_valid_name": "Please enter a valid last name",
        "error_address": "Please enter your address line 1",
        "error_city": "Please enter your city",
        "error_phone": "Please enter your phone number",
        "error_phone_valid": "Please enter a valid phone number",
        "error_phone_char_limit": "Your phone number cannot be longer than 127 characters",
      }
    },
    "it": {
      "form": {
        "error_email": "Inserisci il tuo indirizzo e-mail.",
        "error_valid_email": "Inserisci un indirizzo e-mail valido",
        "error_email_char_limit":"Il tuo indirizzo e-mail non può superare i 100 caratteri",
        "error_password_blank": "Inserisci la password.",
        "error_password_limit": "La password deve avere almeno 6 caratteri",
        "error_password_validate":"La password deve contenere numeri, lettere e caratteri speciali",
         "error_first_name": "Please enter your first name",
        "error_first_valid_name": "Please enter a valid first name",
        "error_last_name": "Please enter your last name",
        "error_last_valid_name": "Please enter a valid last name",
        "error_address": "Inserisci indirizzo riga 1",
        "error_city": "Inserisci città",
        "error_phone": "Inserisci un numero di telefono valido",
        "error_phone": "Inserisci il tuo numero di telefono",
        "error_phone_valid": "Inserisci un numero di telefono valido",
        "error_phone_char_limit": "Il tuo numero di telefono non può superare i 127 caratteri",
      }
    },
    "zh-CN": {
      "form": {
        "error_email": "请输入您的邮箱地址.",
        "error_valid_email": "请输入有效邮箱地址",
        "error_email_char_limit":"您的邮箱地址不可超过100字",
        "error_password_blank": "请输入密码.",
        "error_password_limit": "密码至少为6个字",
        "error_password_validate":"密码须包含数字、字母与特殊符号",
         "error_first_name": "Please enter your first name",
        "error_first_valid_name": "Please enter a valid first name",
        "error_last_name": "Please enter your last name",
        "error_last_valid_name": "Please enter a valid last name",
        "error_address": "请输入您的 地址栏1",
        "error_city": "请输入您的 城市",
        "error_phone": "请输入有效电话号码",
        "error_phone_valid": "请输入有效电话号码",
        "error_phone_char_limit": "您的电话号码不可多余 127 个字符",
        
      }
    },
    "de": {
      "form": {
        "error_email": "Bitte gib deine Email-Adresse ein.",
        "error_valid_email": "Bitte gib eine gültige Email-Adresse ein",
         "error_email_char_limit":"Deine Emailadresse darf nicht länger als 100 Zeichen sein",
        "error_password_blank": "Bitte Passwort eingeben.",
        "error_password_limit": "Das Passwort muss mindestens 6 Zeichen lang sein",
        "error_password_validate":"Passwort muss Zahlen, Buchstaben und Sonderzeichen enthalten",
         "error_first_name": "Please enter your first name",
        "error_first_valid_name": "Please enter a valid first name",
        "error_last_name": "Please enter your last name",
        "error_last_valid_name": "Please enter a valid last name",
        "error_address": "Bitte gib dein adresse zeile 1 ein",
        "error_city": "Bitte gib eine gültige Telefonnummer ein",
         "error_phone": "Bitte gib deine Telefonnummer ein",
        "error_phone_valid": "Bitte gib eine gültige Telefonnummer ein",
        "error_phone_char_limit": "Deine Telefonnummer darf nicht länger als 127 Zeichen sein",
      }
    }
  };

// document.addEventListener("DOMContentLoaded", function () {
//     // Get the selected language from the locale selector
//     const languageSelector = document.querySelector('[name="locale_code"]');
//     const currentLanguage = languageSelector ? languageSelector.value : "en"; // Default to 'en' if not found

//     // Fallback to English if the selected language is not in translations
//     const lang = translations[currentLanguage] ? currentLanguage : "en";
//     const loginButton = document.querySelector(".loginButton");
//     const togglePassword = document.getElementById("togglePassword");
//     const passwordField = document.getElementById("CustomerPassword");

//   if (togglePassword && passwordField) {
//     // Show the password visibility icon when the user starts typing
//     passwordField.addEventListener("input", function () {
//       if (passwordField.value.length > 0) {
//         togglePassword.style.display = "inline-block"; // Show the icon when text is entered
//       } else {
//         togglePassword.style.display = "none"; // Hide the icon when the field is empty
//       }
//     });

//     // Toggle password field visibility and update button content
//     togglePassword.addEventListener("click", function () {
//       // Toggle password field type
//       const isPassword = passwordField.type === "password";
//       passwordField.type = isPassword ? "text" : "password";

//       // Update button content
//       this.innerHTML = isPassword
//         ? "👁️" // Show the "Show Password" icon
//         : `<img 
//             src="https://cdn.shopify.com/s/files/1/0867/7212/1944/files/B.svg?v=1732875533" 
//             alt="Hide Password" 
//             style="width: 20px; height: 20px;"
//           >`; // Show the "Hide Password" image
//     });
//   }
//     if (loginButton) {
//       loginButton.addEventListener("click", function (event) {
//         // Prevent form submission
//         event.preventDefault();

//         // Get field values
//         const emailField = document.getElementById("CustomerEmail");
//         const passwordField = document.getElementById("CustomerPassword");
//         const emailError = document.getElementById("login-email-error");
//         const passwordError = document.getElementById("login-password-error");
//         const emailFormat = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; // Basic email validation regex

//         // Reset error messages
//         emailError.style.display = "none";
//         passwordError.style.display = "none";

//         // Validation logic
//         let hasError = false;

//             if (!emailField.value.trim()) {
//             emailError.textContent = translations[lang].form.error_email;
//             emailError.style.display = "block";
//             hasError = true;
//         } else if (!emailFormat.test(emailField.value)) {
//             emailError.textContent = translations[lang].form.error_valid_email;
//             emailError.style.display = "block";
//             hasError = true;
//         } else if (emailField.value.length > 100) {
//             emailError.textContent = translations[lang].form.error_email_char_limit;
//             emailError.style.display = "block";
//             hasError = true;
//         }


//         if (!passwordField.value.trim()) {
//           passwordError.textContent = translations[lang].form.error_password_blank;
//           passwordError.style.display = "block";
//           hasError = true;
//         } else if (passwordField.value.length < 6) {
//           passwordError.textContent = translations[lang].form.error_password_limit;
//           passwordError.style.display = "block";
//           hasError = true;
//         } else if (
//           !/[A-Za-z]/.test(passwordField.value) || 
//           !/[0-9]/.test(passwordField.value) || 
//           !/[^A-Za-z0-9]/.test(passwordField.value)
//         ) {
//           passwordError.textContent = translations[lang].form.error_password_validate;
//           passwordError.style.display = "block";
//           hasError = true;
//         } else {
//           // Clear error if validation passes
//           passwordError.textContent = "";
//           passwordError.style.display = "none";
//           hasError = false;
//         }


//         // If validation passes, submit the form
//         if (!hasError) {
//           loginButton.closest("form").submit();
//         }
//       });
//     }
//   });


document.addEventListener("DOMContentLoaded", function () {
  // Get the selected language from the locale selector
  const languageSelector = document.querySelector('[name="locale_code"]');
  const currentLanguage = languageSelector ? languageSelector.value : "en"; // Default to 'en' if not found

  // Fallback to English if the selected language is not in translations
  const lang = translations[currentLanguage] ? currentLanguage : "en";
  const loginButton = document.querySelector(".loginButton");
  const togglePassword = document.getElementById("togglePassword");
  const passwordField = document.getElementById("CustomerPassword");

  if (togglePassword && passwordField) {
    // Show the password visibility icon when the user starts typing
    passwordField.addEventListener("input", function () {
      if (passwordField.value.length > 0) {
        togglePassword.style.display = "inline-block"; // Show the icon when text is entered
      } else {
        togglePassword.style.display = "none"; // Hide the icon when the field is empty
      }
    });

    // Toggle password field visibility and update button content
    togglePassword.addEventListener("click", function () {
      // Toggle password field type
      const isPassword = passwordField.type === "password";
      passwordField.type = isPassword ? "text" : "password";

      // Update button content
      this.innerHTML = isPassword
        ? "👁️" // Show the "Show Password" icon
        : `<img 
              src="https://cdn.shopify.com/s/files/1/0867/7212/1944/files/B.svg?v=1732875533" 
              alt="Hide Password" 
              style="width: 20px; height: 20px;"
            >`; // Show the "Hide Password" image
    });
  }

  if (loginButton) {
    loginButton.addEventListener("click", function (event) {
      // Prevent form submission
      event.preventDefault();

      // Get field values
      const emailField = document.getElementById("CustomerEmail");
      const passwordField = document.getElementById("CustomerPassword");
      const emailError = document.getElementById("login-email-error");
      const passwordError = document.getElementById("login-password-error");
      const emailFormat = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; // Basic email validation regex

      // Reset error messages
      emailError.style.display = "none";
      passwordError.style.display = "none";

      // Validation logic
      let hasError = false;

      // Email validations
      if (!emailField.value.trim()) {
        emailError.textContent = translations[lang].form.error_email;
        emailError.style.display = "block";
        hasError = true;
      } else if (!emailFormat.test(emailField.value)) {
        emailError.textContent = translations[lang].form.error_valid_email;
        emailError.style.display = "block";
        hasError = true;
      } else if (emailField.value.length > 100) {
        emailError.textContent = translations[lang].form.error_email_char_limit;
        emailError.style.display = "block";
        hasError = true;
      }

      // Password validations
      if (!passwordField.value.trim()) {
        passwordError.textContent = translations[lang].form.error_password_blank;
        passwordError.style.display = "block";
        hasError = true;
      } else if (passwordField.value.length < 6) {
        passwordError.textContent = translations[lang].form.error_password_limit;
        passwordError.style.display = "block";
        hasError = true;
      }

      // Commented out password complexity validation as per request
      /*
      else if (
        !/[A-Za-z]/.test(passwordField.value) || 
        !/[0-9]/.test(passwordField.value) || 
        !/[^A-Za-z0-9]/.test(passwordField.value)
      ) {
        passwordError.textContent = translations[lang].form.error_password_validate;
        passwordError.style.display = "block";
        hasError = true;
      }
      */
      else {
        // Clear error if validation passes
        passwordError.textContent = "";
        passwordError.style.display = "none";
      }

      // If validation passes, submit the form
      if (!hasError) {
        loginButton.closest("form").submit();
      }
    });
  }
});



 document.addEventListener("DOMContentLoaded", function () {
  // Get the selected language from the locale selector
  const languageSelector = document.querySelector('[name="locale_code"]');
  const currentLanguage = languageSelector ? languageSelector.value : "en"; // Default to 'en' if not found

  // Fallback to English if the selected language is not in translations
  const lang = translations[currentLanguage] ? currentLanguage : "en";

  const filledBtn = document.querySelector(".filledBtn");

  if (filledBtn) {
    filledBtn.addEventListener("click", function (event) {
      // Prevent form submission
      event.preventDefault();

      // Get field values
      const recoveremail = document.getElementById("RecoverEmail");
      const recoveremailerror = document.getElementById("recover-email-error");
      const emailFormat = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; // Basic email validation regex

      // Reset error messages
      recoveremailerror.style.display = "none";

      // Validation logic
      let hasError = false;

      if (!recoveremail.value.trim()) {
        recoveremailerror.textContent = translations[lang].form.error_email;
        recoveremailerror.style.display = "block";
        hasError = true;
      } else if (!emailFormat.test(recoveremail.value)) {
        recoveremailerror.textContent = translations[lang].form.error_valid_email;
        recoveremailerror.style.display = "block";
        hasError = true;
      } else if (recoveremail.value.length > 100) {
        recoveremailerror.textContent = translations[lang].form.error_email_char_limit;
        recoveremailerror.style.display = "block";
        hasError = true;
      }

      // If validation passes, submit the form
      if (!hasError) {
        filledBtn.closest("form").submit();
      }
    });
  }
});
/*********************************************** main address form validation ***************************************/

 


document.addEventListener("DOMContentLoaded", function () {
  // Get the selected language from the locale selector
  const languageSelector = document.querySelector('[name="locale_code"]');
  const currentLanguage = languageSelector ? languageSelector.value : "en"; // Default to 'en' if not found

  // Fallback to English if the selected language is not in translations
  const lang = translations[currentLanguage] ? currentLanguage : "en";

  const mainaddressbtn = document.querySelector(".main-address-btn");

  // Function to clear specific error
  function clearError(inputField, errorSpan) {
    if (inputField.value.trim() !== '') {
      errorSpan.style.display = 'none';
    }
  }

  if (mainaddressbtn) {
    mainaddressbtn.addEventListener("click", function (event) {
      // Prevent form submission
      event.preventDefault();

      // Get field values
      const addressfirstname = document.getElementById("AddressFirstNameNew");
      const addressfirstnameerror = document.getElementById("custom-first-name-error");
      const addresslastname = document.getElementById("AddressLastNameNew");
      const addresslastnameerror = document.getElementById("custom-last-name-error");
      const addressaddress = document.getElementById("AddressAddress1New");
      const customaddresserror = document.getElementById("custom-address-error");
      const addresscity = document.getElementById("AddressCityNew");
      const customaddresscityerror = document.getElementById("custom-city-error");
      const addressphone = document.getElementById("AddressPhoneNew");
       const customcityphoneerror = document.getElementById("custom-phone-error");

      // Regular expression for name validation (e.g., letters only)
      const format = /^[A-Za-z]+$/;

      // Reset error messages before validation
      addressfirstnameerror.style.display = "none";
      addresslastnameerror.style.display = "none";
      customaddresserror.style.display = "none";
      customaddresscityerror.style.display = "none";
      customcityphoneerror.style.display = "none";

      // Validation logic
      let hasError = false;

      // Validate First Name
      if (!addressfirstname.value.trim()) {
        addressfirstnameerror.textContent = translations[lang].form.error_first_name;
        addressfirstnameerror.style.display = 'block';
        hasError = true;
      } else if (!format.test(addressfirstname.value)) {
        addressfirstnameerror.textContent = translations[lang].form.error_first_valid_name;
        addressfirstnameerror.style.display = 'block';
        hasError = true;
      }

      // Validate Last Name
      if (!addresslastname.value.trim()) {
        addresslastnameerror.textContent = translations[lang].form.error_last_name;
        addresslastnameerror.style.display = 'block';
        hasError = true;
      } else if (!format.test(addresslastname.value)) {
        addresslastnameerror.textContent = translations[lang].form.error_last_valid_name;
        addresslastnameerror.style.display = 'block';
        hasError = true;
      }

      // Validate Address
      if (!addressaddress.value.trim()) {
        customaddresserror.textContent = translations[lang].form.error_address;
        customaddresserror.style.display = 'block';
        hasError = true;
      } 

      // Validate City
      if (!addresscity.value.trim()) {
        customaddresscityerror.textContent = translations[lang].form.error_city;
        customaddresscityerror.style.display = 'block';
        hasError = true;
      } 

              // Regular expression for validating phone numbers (can include spaces, dashes, or parentheses)
        const phoneFormat = /^[\d\(\)\-\+\s]+$/;
        
            // Validate Phone
    if (!addressphone.value.trim()) {
      customcityphoneerror.textContent = translations[lang].form.error_phone;
      customcityphoneerror.style.display = 'block';
      hasError = true;
    } else if (!phoneFormat.test(addressphone.value)) {
      customcityphoneerror.textContent = translations[lang].form.error_phone_valid;
      customcityphoneerror.style.display = 'block';
      hasError = true;
    } else if (addressphone.value.length > 127) { // New validation
      customcityphoneerror.textContent = translations[lang].form.error_phone_char_limit;
      customcityphoneerror.style.display = 'block';
      hasError = true;
    } else {
      // Handle success or proceed if validation passes
      customcityphoneerror.style.display = 'none'; // Hide error if valid
    }


      // If validation passes, submit the form
      if (!hasError) {
        mainaddressbtn.closest("form").submit();
      }
    });

    // Real-time validation to clear error on input
   const fields = [
    { id: "AddressFirstNameNew", errorId: "custom-first-name-error" },
    { id: "AddressLastNameNew", errorId: "custom-last-name-error" },
    { id: "AddressAddress1New", errorId: "custom-address-error" },
    { id: "AddressCityNew", errorId: "custom-city-error" },
    { id: "AddressPhoneNew", errorId: "custom-phone-error" } // Uncomment this line
];

    fields.forEach(function (field) {
      const inputField = document.getElementById(field.id);
      const errorSpan = document.getElementById(field.errorId);

      if (inputField) {
        inputField.addEventListener('input', () => clearError(inputField, errorSpan));
      }
    });

    // Optionally: Add event listener for 'change' on dropdown (if necessary)
    const country = document.getElementById('AddressCountryNew');
    const countryErrorSpan = document.getElementById('custom-country-error');
    if (country) {
      country.addEventListener('change', () => clearError(country, countryErrorSpan));
    }
  }
});





